(function () {
  function updateWithinWrapper(wrapper) {
    if (!wrapper) return;

    var labelEl = wrapper.querySelector('[data-variant-color-label]');
    if (!labelEl) return;

    var optionIndexAttr = labelEl.getAttribute('data-option-index');
    if (optionIndexAttr == null) return;

    var optionIndex = parseInt(optionIndexAttr, 10);
    if (Number.isNaN(optionIndex)) return;

    // optionIndex é 0-based; fieldset usa option{1..}
    var fieldset = wrapper.querySelector(
      'fieldset.variant-input-wrap[data-index="option' + (optionIndex + 1) + '"]'
    );
    if (!fieldset) return;

    var checked = fieldset.querySelector('input[type="radio"][data-variant-input]:checked');
    if (!checked) return;

    labelEl.textContent = checked.value;
  }

  function updateNearest(target) {
    var wrapper = target && target.closest ? target.closest('.variant-wrapper.js') : null;
    if (!wrapper) return;
    updateWithinWrapper(wrapper);
  }

  // Atualiza no load
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.variant-wrapper.js').forEach(updateWithinWrapper);
  });

  // Atualiza após o Impulse processar a troca (sem capture, sem observer)
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches('input[type="radio"][data-variant-input]')) return;

    // Deixa o tema processar a variante primeiro, depois atualiza o texto
    setTimeout(function () {
      updateNearest(t);
    }, 0);
  });

  // Se o Impulse disparar evento de variant change, usamos também (não é obrigatório)
  document.addEventListener('variant:change', function () {
    document.querySelectorAll('.variant-wrapper.js').forEach(updateWithinWrapper);
  });
})();
